import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import esrimap from '@/components/esri-map'
import RoomTable from '@/components/RoomTable'
import LeftSidebar from '@/components/LeftSidebar'
import Login from '@/components/Login'
import Stats from '@/components/Stats'
import About from '@/components/About'
import Dashboard from '@/components/dashboard/Dashboard'
import Feedback from '@/components/Feedback'
import bldgviewer from '@/components/forms/BldgViewer/BldgViewer'
import RoomViewer from '@/components/RoomViewer/RoomViewer'
import AmenitiesListEditor from '@/components/roomAmenities/AmenitiesListEditor'
import RoomCollections from '@/components/RoomCollector/RoomCollections'
import TestLayout from '@/components/TestLayout'
import setBetaGIS from '@/components/setBetaGIS'
import UpdateOccupancy from '@/components/UpdateOccupancy'
import SummaryDashboard from '@/components/SummaryDashboard'
import jscookie from 'js-cookie'
import { AUTH_COOKIE } from '../store/modules/user'

Vue.use(Router)

const checkAuth = () => (to, from, next) => {
  const { dispatch, state } = store

  let token = jscookie.get(AUTH_COOKIE)

///////////////////////////////////////////////////////////////		// UPPER BLOCK ENFORCES LOGIN

  if (!token) {
    next({ path: '/login', query: { redirect: to.path } })
  } else {  	
  	// This will check for local copies of data and fetch if necessary.
  	dispatch('initializeData').then(() => next())
  }

}

/*const deptSearch = () => (to, from, next) => {
	console.log("Route: Dept Search")
	store.commit('updateSearchResultSidebar', true)
    //this.setLoading("dept")
	store.dispatch('fetchDept', to.params.deptID).then((data) => {

	    const subtitle =    `<div style="background-color: #383838;color: white;padding: 25px;margin-left: -25px;margin-top: -25px;">
	                                    <div class="headline">${data.deptName}</div>
	                                    <div style="margin-bottom: 10px;">${data.deptID}</div>
	                                    <div>Total Area: ${data.areaSum.toLocaleString()}</div>
	                                    <div>Bldg Count: ${data.bldgCount}</div>
	                                    <div>Room Count: ${data.roomCount}</div>
	                            `

	    store.commit('setSearchResults', data)
	    store.commit('setSearchTitle', "Department Search")
	    store.commit('setSearchSubtitle', subtitle)
	    store.commit('setSearchSort', "bldgAlpha")
	    store.commit('updateMainSidebar', false)          
	    store.commit('updateSearchResultSidebar', true)
	    store.commit('unSetLoading', "dept")
	})

}*/

export default new Router({
	mode: 'history',
	routes: [
	   {
	    	path: '/', 
	    	name: 'home',
	    	beforeEnter: checkAuth(),
	    	component: esrimap,
	    	children: [
				    {
				      	path: 'roomtable/:bldg',
				    	name: 'roomtableBldg',
				    	component: RoomTable
				    },
				    {
				      path: 'roomcollections/share/:link',
				    	name: 'roomCollectionsShare',
				    	component: esrimap,
				    },
				    {
				      	path: 'about',
				    	name: 'about',
				    	component: About
				    },
				    {
				      	path: 'feedback',
				    	name: 'feedback',
				    	component: Feedback
				    },
				     {
				      	path: 'reports',
				    	name: 'reports',
				    	component: Dashboard
				    },
				    {
				    	path: '/amenities',
				    	name: 'amenities',
				    	component: AmenitiesListEditor
				    },
				    {
				    	path: '/roomviewer',
				    	name: 'roomviewer',				    	
				    	component: RoomViewer
				    },
				    {
				    	path: '/roomviewer/building/:rvbldg',
				    	name: 'RoomViewerToBldg',				    	
				    	component: RoomViewer
				    },
				    {
				    	path: '/roomviewer/building/:rvbldg/:rvroom',
				    	name: 'RoomViewerToBldgRoom',				    	
				    	component: RoomViewer
				    },
				    {
				    	path: '/roomviewer/dept/:deptID',
				    	name: 'RoomViewerToDept',				    	
				    	component: RoomViewer
				    },
				    {
				    	path: '/roomviewer/college/:collegeID',
				    	name: 'RoomViewerToCollege',				    	
				    	component: RoomViewer
				    },
				    {
				    	path: '/bldgviewer',
				    	name: 'bldgviewer',
				    	beforeEnter: checkAuth(),
				    	component: bldgviewer
				    },
				    
				    {
				    	path: '/bldgviewer/:dvbldg',
				    	name: 'bldgviewerToBuilding',
				    	beforeEnter: checkAuth(),
				    	component: bldgviewer
				    },
			    
	    	]
	    },
	    {
	    	path: '/stats',
	    	name: 'stats',
	    	beforeEnter: checkAuth(),
	    	component: Stats
	    },
	    {
	    	path: '/updateoccupancy',
	    	name: 'updateOccupancy',
	    	beforeEnter: checkAuth(),
	    	component: UpdateOccupancy
	    },
	    	    
	    {
	    	path: '/login',
	    	name: 'login',
	    	component: Login
	    },
	    { 
	      	path: '/logout',
	      	beforeEnter(to, from, next) {
	        	store.dispatch('logout').then(() => {
	        	store.commit('updateMainSidebar', false)
	          	next('/login')
	        	})
	      	}
	    },
	    {
	    	path: '/testlayout',
	    	name: 'testlayout',
	    	component: TestLayout
	    },

	   {
	    	path: '/summary',
	    	name: 'summaryDashboard',
	    	component: SummaryDashboard
	    },

	    {
	    	path: '/betagis',
	    	name: 'betagis',
	    	component: setBetaGIS,
	    },

	    // I had changed these to be /goto/:bldg/:room.  And don't remember why.  Ive put it back how it was for now.
	    // I think I remember it having a conflict with how bldgviewer route was working.
	    // THESE MUST BE LAST
		{
	    	path: '/:bldg',
	    	name: 'highlightBuilding', 
	    	beforeEnter: checkAuth(),
	    	component: esrimap
	    },
	    {
	    	path: '/:bldg/:room',
	    	name: 'highlightRoom', 
	    	beforeEnter: checkAuth(),
	    	component: esrimap
	    },



	    
	    
	    

	    
	    


	]
})



// WEBPACK FOOTER //
// ./src/router/index.js